'use client';

import { unlockVideo } from "@/app/actions/unlock";
import { useRouter } from "next/navigation";
import { MouseEvent, useState } from "react";
import { useNavigation } from '@/app/navigation-context';

export default function UnlockVideoButton({ brandId, slug, }: { brandId: number, slug: string }) {
  const router = useRouter();
  const [isDisabled, setIsDisabled,] = useState(false);
  const { startLoading, stopLoading, } = useNavigation();
  const handleClick = async (event: MouseEvent) => {
    event.preventDefault();
    setIsDisabled(true);
    startLoading(`/video/${slug}`);
    await unlockVideo(brandId, slug);
    router.refresh();
    stopLoading();
  };

  return <a href='#' style={isDisabled ? {
    pointerEvents: `none`,
    cursor: `default`,
  } : {}} onClick={handleClick}>UNLOCK</a>;
}
